import { createPostEndpoint } from '@sonar-software/sonar-http';

export const postLogout = createPostEndpoint<void, void>(
	'/api/v3/security/authentication/logout', {
		skipAuthRefresh: true
	}
);

